import type { OfficeSuite } from "@/shared/utils/PrintUtils";
import {
  OFFICE_SUITE_LIBRE_OFFICE,
  OFFICE_SUITE_MS_OFFICE,
} from "@/shared/utils/PrintUtils";
import type { GenericPreferences } from "./GenericPreferences";

export class DomainPreferences {
  constructor(readonly rawValues: GenericPreferences) {}

  officeSuite(): OfficeSuite {
    const value = this.rawValues.getString(
      "jenova.domain.core.SUITE_BUREAUTIQUE",
    );
    if (
      value === OFFICE_SUITE_MS_OFFICE ||
      value === OFFICE_SUITE_LIBRE_OFFICE
    ) {
      return value;
    }
    return OFFICE_SUITE_MS_OFFICE;
  }
}
